'use strict';

var jsxRuntime = require('react/jsx-runtime');

var o=jsxRuntime.jsx("g",{width:"15",height:"9",viewBox:"0 0 15 9",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:jsxRuntime.jsx("path",{d:"M14.625 0H0.375C0.16875 0 0 0.15 0 0.333333V8.66667C0 8.85 0.16875 9 0.375 9H14.625C14.8313 9 15 8.85 15 8.66667V0.333333C15 0.15 14.8313 0 14.625 0ZM13.725 0.666667L7.5 6.2L1.275 0.666667H13.725ZM0.75 1.13333L4.5375 4.5L0.75 7.86667V1.13333ZM1.29375 8.33333L5.0625 4.98333L7.2375 6.91667C7.3875 7.05 7.6125 7.05 7.7625 6.91667L9.9375 4.98333L13.7062 8.33333H1.29375ZM14.25 7.86667L10.4625 4.5L14.25 1.13333V7.86667Z",fill:"#8A8A8A"})});

exports.IconEnvelope = o;
